<template>
  <div>
    <h1 class="text-h1 mb-16">Welcome! Your Premium access is now active.</h1>
    <p class="pb-16 text-body text-grey-body">
      Your employer-sponsored membership now gives you access to messaging sitters and premium features on Sittercity.
    </p>
    <Button class="w-full" variant="primary" value="Get started" size="medium" to="/account/seekers/dashboard" />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

export default {
  name: 'VerifyCorporateUpgradeSuccess',
  components: {
    Button,
  },
};
</script>
